import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArticleExcelImport } from 'src/app/shared/models/article-excel-import.model';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  /**
   * Use the first apiUrl for dev API access and the second for development with local backend.
   */
  apiUrl = environment.apiUrl;
  // apiUrl = environment.localUrl;

  constructor(private http: HttpClient) { }

  /**
   * Retrieves a presigned URL from the backend for the passed in articleId.
   * @param articleId the articleId to retrieve a presigned URL for
   * @returns an observable of the presigned URL
   */
  getPresignedUrl(articleId: string, artifactType: string): Observable<string> {
    return this.http.get(`${this.apiUrl}/api/FileManagement/GeneratePreSignedURL/${articleId}/${artifactType}`, {responseType: 'text'});
  }

   getPresignedUrlForUploadObject(articleId: string, artifactType: string): Observable<string> {
    return this.http.get(`${this.apiUrl}/api/FileManagement/GetPreSignedURLForUploadObject/${articleId}/${artifactType}`, {responseType: 'text'});
  }

  /**
   * Uploads the passed in file to the passed in presigned URL via the backend.
   * @param presignedUrl the presigned URL to upload the file to
   * @param file the file to upload
   * @returns an observable of the upload
   * @deprecated use `uploadFileToPresignedURL()` instead
   */
  uploadDxfFile(presignedUrl: string, file: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'image/vnd.dxf' });
    const req = new HttpRequest(
      'PUT',
      presignedUrl,
      file,
      {
        headers: headers, 
      }
    );
    return this.http.request(req);
  }

  /**
   * Uploads an array of articles from the passed in excel file to the backend.
   * @param articles the array of articles to upload.
   * @returns an observable of the upload.
   */
  uploadImportedArticles(articles: ArticleExcelImport[]): Observable<any> {
    console.log('uploadImportedArticles', articles);
    return this.http.post(`${this.apiUrl}/api/Article/UploadImportedArticleToDB`, articles)
  }

  /**
   * Uploads the passed in thermal data from the excel to the mapped endpoint.
   * @param thermalOption thermal option determined by dropdown selection.
   * @param rows the rows of thermal data to upload.
   * @returns an observable of the upload.
   */
  uploadThermalData(thermalOption: string, rows: any[]): Observable<any> | any {
    return this.http.post(`${this.apiUrl}/api/ThermalRefactor/Import${thermalOption}FromExcel`, rows);
  }

  /**
   * Uploads the passed in file to the passed in presigned URL via the backend.
   * @param file the file to upload
   * @param presignedUrl the presigned URL to upload the file to
   * @returns an observable of the upload
   * @throws an error if the upload is unsuccessful
   */
  uploadFileToPresignedURL(file: any, presignedUrl: string): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("url", presignedUrl);
    let url: string = `${this.apiUrl}/api/FileManagement/UploadObjectToPresignedURL`;
    return this.http.post(url, formData, { responseType: 'text' });
  }

}